import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

import { Stack, Select, Button, MenuItem, InputLabel, FormControl } from '@mui/material';

function AddFavoriteModal({ departmentsList, forms, onSubmit }) {
  const [selectedDepartment, setSelectedDepartment] = useState('');
  const [formsList, setFormsList] = useState([]);

  const { t } = useTranslation();
  const { register, handleSubmit, watch } = useForm({
    defaultValues: {
      type: 'form',
      typeId: 0,
    },
  });
  const selectedType = watch('type');
  const handleChangeDepartment = (e) => {
    setSelectedDepartment(e.target.value);
    setFormsList(forms.filter((ticket) => ticket.departmentId === e.target.value));
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <Stack py={2} spacing={2} width="100%">
        <FormControl fullWidth>
          <InputLabel id="type-select-label">{t('favorites.selectType')}</InputLabel>
          <Select
            labelId="type-select-label"
            label={t('favorites.selectType')}
            defaultValue="form"
            value={watch('type') || ''}
            disabled
            {...register('type', {
              required: t('formControl.typeRequired'),
            })}
          >
            {['form', 'ticket', 'user'].map((type, index) => (
              <MenuItem key={index} value={type}>
                {t(`favorites.${type}`)}
              </MenuItem>
            ))}
          </Select>
        </FormControl>

        {selectedType === 'form' && (
          <FormControl fullWidth>
            <InputLabel id="department-select-label">
              {t('favorites.selectDepartment')}
            </InputLabel>
            <Select
              labelId="department-select-label"
              onChange={handleChangeDepartment}
              value={selectedDepartment || ''}
              label={t('favorites.selectDepartment')}
            >
              {departmentsList.length > 0 ? (
                departmentsList.map((department) => {
                  const { id, name } = department;
                  return (
                    <MenuItem key={id} value={id}>
                      {name}
                    </MenuItem>
                  );
                })
              ) : (
                <MenuItem disabled value="">
                  {t('infoMessages.noOptions')}
                </MenuItem>
              )}
            </Select>
          </FormControl>
        )}

        {selectedDepartment && (
          <FormControl fullWidth>
            <InputLabel id="form-select-label">{t('favorites.selectForm')}</InputLabel>
            <Select
              labelId="form-select-label"
              label={t('favorites.selectForm')}
              value={watch('typeId') || ''}
              {...register('typeId', { required: t('formControl.formRequired') })}
            >
              {formsList.length > 0 ? (
                formsList.map((form) => {
                  const { id, title } = form;
                  return (
                    <MenuItem key={id} value={id}>
                      {title}
                    </MenuItem>
                  );
                })
              ) : (
                <MenuItem disabled value="">
                  {t('infoMessages.noOptions')}
                </MenuItem>
              )}
            </Select>
          </FormControl>
        )}
        <Button variant="contained" color="primary" type="submit">
          {t('favorites.addNewFavorite', { type: t(`favorites.${selectedType}`) })}
        </Button>
      </Stack>
    </form>
  );
}

AddFavoriteModal.propTypes = {
  departmentsList: PropTypes.array,
  forms: PropTypes.array,
  onSubmit: PropTypes.func.isRequired,
};

export default AddFavoriteModal;
